module.exports = __webpack_public_path__ + "static/media/KEVIN_REAL-ESTATE.9cafafb5.png";